import { render, staticRenderFns } from "./header-shopping-cart-area.vue?vue&type=template&id=1cc838df&scoped=true&"
import script from "./header-shopping-cart-area.vue?vue&type=script&lang=ts&"
export * from "./header-shopping-cart-area.vue?vue&type=script&lang=ts&"
import style0 from "./header-shopping-cart-area.vue?vue&type=style&index=0&id=1cc838df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cc838df",
  null
  
)

export default component.exports